import type { AttributeTableSlice, GeoDataStateCreator } from './types';

export const createAttributeTableSlice: GeoDataStateCreator<AttributeTableSlice> = (set) => ({
  openAttributeTableIds: [], // Stato iniziale: nessuna tabella aperta

  openAttributeTable: (layerId) =>
    set((state) => {
      // Aggiungi l'ID solo se non è già presente
      if (!state.openAttributeTableIds.includes(layerId)) {
        return { openAttributeTableIds: [...state.openAttributeTableIds, layerId] };
      }
      return {}; // Non fare nulla se già presente
    }),

  closeAttributeTable: (layerId) =>
    set((state) => ({
      openAttributeTableIds: state.openAttributeTableIds.filter(id => id !== layerId),
    })),

  closeAllAttributeTables: () =>
    set({ openAttributeTableIds: [] }), // Svuota l'array
});